import * as yup from 'yup';

const status = yup.object().shape({
  isActive: yup.object().shape({
    value: yup.string(),
    label: yup.string(),
  }).nullable().required('common.required'),
});

const quantity = yup.object().shape({
  quantity: yup.number().required('common.required'),
});

const yielding = yup.object().shape({
  yielding: yup.number().required('common.required'),
});

const batchEditionByType = {
  status,
  quantity,
  yielding,
};

export default batchEditionByType;
